import {connect} from 'react-redux';
import axios from 'axios';
import {Platform} from "react-native";
import i18n from "../../../../../I18n/i18n";

import AddTaskOperationSatiaScreen from "../AddTaskOperationSatiaScreen";
import store from "../../../../../redux/store";
import {typeExport} from "../../../../../redux/store/type";
import HMAlert from "../../../../../customviews/HMAlert";
import * as NavigationService from "../../../../../redux/NavigationService";
import {AsyngStorageClass} from "../../../../../tools/AsyngStorageClass";

const mapStateToProps = (state) => ({
    // item_count: state.reducerSplashSatiaScreen.results.item_count,
    allResult: state.reducerAddTaskOperationSatiaScreen.allResult,
    results: state.reducerAddTaskOperationSatiaScreen.results,
    NoInternetDialog: state.reducerAddTaskOperationSatiaScreen.NoInternetDialog,
    isLoading: state.reducerAddTaskOperationSatiaScreen.isLoading,
    lazyload_end: state.reducerAddTaskOperationSatiaScreen.lazyload_end,
    showRefresh: state.reducerAddTaskOperationSatiaScreen.showRefresh,
    failed: state.reducerAddTaskOperationSatiaScreen.failed,
    page: state.reducerAddTaskOperationSatiaScreen.page,
    empty: state.reducerAddTaskOperationSatiaScreen.empty,
    DataSplashScreen: state.reducerSplashSatiaScreen,
    resultsSet: state.reducerAddTaskOperationSatiaScreen.resultsSet,
    isLoadingSet: state.reducerAddTaskOperationSatiaScreen.isLoadingSet,
    NoInternetDialogSet: state.reducerAddTaskOperationSatiaScreen.NoInternetDialogSet,
    ListFilter: state.reducerAddTaskOperationSatiaScreen.ListFilter,
    id: state.reducerAddTaskOperationSatiaScreen.id,
    DataSplashSatiaScreen: state.reducerSplashSatiaScreen,

});

const mapDispatchToProps = (dispatch, getState) => ({
    callService: (url, params, type, typeConnection, page, item_count, id, func) => dispatch(callWebservice(getState, url, params, type, typeConnection, page, item_count, id, func)),
    callServiceAddFirst: (data, item_count) => dispatch(serviceActionAddFirstData(data, item_count)),
    callServiceChangeNotif: (data) => dispatch(serviceActionChangeNotif(data)),
    callserviceActionRefresh: () => dispatch(serviceActionRefresh()),
    callserviceActionListFilter: (data) => dispatch(serviceActionListFilter(data)),
    // callServiceSuccess: (data,page) => dispatch(serviceActionSuccess(data,page)),

})

const getDataDisatch = (dispatch, getState, url, params, type, typeConnection, page, item_count, id, func) => {
    let pagee;
    let url_send = "";

    switch (type) {
        case typeExport.TypeGetAddTaskOperationSatiaScreen:
            url_send = typeExport.baseUrl + url + params + `&i=${page}`
            dispatch(serviceActionPending());

            break;
        case typeExport.TypeSetAddTaskOperationSatiaScreen:
            url_send = typeExport.baseUrl + url + params;
            dispatch(serviceActionPendingSet(id))
            break;
        default:
    }


    let formData = new FormData();

    formData.append('token', store.getState().reducerSplashSatiaScreen.token == null ? '' : store.getState().reducerSplashSatiaScreen.token);

    formData.append('adslTell', params.adslTell);
    formData.append('categoryType', params.categoryType);
    formData.append('title', params.title);
    formData.append('description', params.description);
    formData.append('status', params.status);
    formData.append('ccTo', params.ccTo);
    formData.append('workTime', params.workTime? params.workTime:null);
    formData.append('priority', params.priority);
    formData.append('referTo', params.referTo);
    formData.append('platform', Platform.OS);


    let DateTime = new Date().getTime()
    let nameImage = DateTime + '.jpg';
    let nameVideo = DateTime + '.mp4';
    let nameAudio = DateTime + '.aac';
    if (params.audio && params.audio !== null) {
        formData.append('durationVoice', params.durationVoice);

        if (Platform.OS === "web") {
            //  formData.append('audio', params.audio, nameAudio + ".aac");
            //  formData.append('audio', params.audioBlob, nameAudio + ".aac");
            formData.append('audio', params.audioBlob, nameAudio);
            //const blobFile = new File([params.audio], nameAudio + ".aac");
            //formData.append("audio", params.audioBlob);
        }
        else
            formData.append('audio', {
                uri: params.audio,
                name: nameAudio,
                type: 'audio/aac'
            });
    }

    // if (params.image && params.image !== null)
    //     if (Platform.OS === "web") {
    //         // formData.append('image', params.image, nameImage + ".JPG");
    //         formData.append('image', params.image, nameImage);
    //
    //     }
    //     else
    //         formData.append('image', {
    //             uri: params.image,
    //             name: nameImage,
    //             type: 'image/jpeg'
    //         });
    if (params.video && params.video !== null) {
        if (Platform.OS === "web") {
            //  formData.append('audio', params.audio, nameAudio + ".aac");
            // formData.append('video', params.video, nameVideo + ".mp4");
            formData.append('video', params.video, nameVideo);
            //const blobFile = new File([params.audio], nameAudio + ".aac");
            //formData.append("audio", params.audioBlob);
        }
        else
            formData.append('video', {
                uri: params.video,
                name: nameVideo,
                type: 'video/mp4'
            });
    }

    if (params.arrImage)
        for (let i = 0; i < params.arrImage.length; i++) {


            if (Platform.OS === "web") {
                //formData.append('image' + "_" + i, params.arrImage[i], `${i}_${nameImage}.JPG`);
                formData.append('image' + "_" + i, params.arrImage[i], `${i}_${nameImage}`);
            }
            else

                formData.append('image' + "_" + i, {
                    uri: params.arrImage[i],
                    name: nameImage,
                    type: 'image/jpeg'
                });
        }
    // formData.append('type', params.type);
    // formData.append('listFilter',JSON.stringify(params.listFilter) );
    // formData.append('trackingCode', params.trackingCode);

    const config = {
        headers: {
            "Content-Type": "multipart/form-data; charset=utf-8;",
            timeout: typeExport._TIMEOUT,
        }
    };

    //  axios.post(url, formData, config)
    axios({
        method: 'post',
        url: url,
        data: formData,
        headers: {'Content-Type': 'multipart/form-data'},
        timeout: typeExport._TIMEOUT,

    })
        .then(async response => {

            switch (type) {

                case typeExport.TypeGetAddTaskOperationSatiaScreen:


                    if (response.data.status) {


                        let data = response.data.result && response.data.result.data ? response.data.result.data : response.data.result;
                        // dispatch(serviceActionListFilter(response.data.result.searchItems));

                        if (data == null) data = []

                        dispatch(serviceActionSuccess(data, pagee, response.data));

                        global._refreshSplashSatiaOperator=true;

                        /*   let arr = store.getState().reducerAddTaskOperationSatiaScreen.results
                           if (page == 1) {
                               arr = data
                               global.list_menu_shahrdar=response.data.result.menu
                           } else {
                               if (arr.length > 0)
                               //    arr.push(data);
                                   arr = [...arr, ...data]
                               else
                                   arr = data
                           }*/

                        // if (data.length == item_count) {
                        //     pagee = page + 1;
                        //     dispatch(serviceActionSuccess(data, pagee, response.data));
                        // }
                        //
                        // else {
                        //     (page === 1 & (data.length == 0)) ?
                        //         dispatch(serviceActionEmpty(page, response.data))
                        //         :
                        //         (pagee = page + 1, dispatch(serviceActionEnd(data, pagee, response.data)));
                        // }


                        // let t=((getState === null || getState === undefined || getState === '') ? id : getState.route.params.data.type);
                        // await AsyngStorageClass.setAsyng(global.IdCity +typeExport.ListMessageOperatorSatia +  t, arr)
                        // if (page == 1)
                        //     await AsyngStorageClass.setAsyng(global.IdCity +typeExport.ListMessageOperatorSatiaFilter + t, response.data.result.searchItems)

                    } else {
                        if (response.data.exit) {
                            AsyngStorageClass.removeToken();
                           // dispatch(serviceActionSuccess(response.data));

                            // Tools.remove();
                            //  NavigationService.resetTo('LoginSatiaStack');

                        }
                        dispatch(serviceActionError(response, page))

                        //alert(response.data.message)
                    }

                    break;

                case typeExport.TypeSetAddTaskOperationSatiaScreen:
                    if (response.data.status) {
                        global._refreshSplashSatiaOperator=true;
                        dispatch(serviceActionSuccessSet(response.data, id));
                        func ? func(1) : null;
                        HMAlert(
                            i18n.t('constant.message'),
                            "با موفقیت ثبت شد",
                            [
                                {
                                    text: i18n.t('constant.ok'), onPress: () => {
                                        NavigationService.BackTo(1)

                                    }


                                },
                                {
                                    // text: i18n.t('constant.NowNot'),
                                    // onPress: () => {
                                    // },
                                    // style: 'cancel'
                                },


                            ],
                            {cancelable: false}
                        )

                        //dispatch(callWebservice(getState, url, params, type, typeConnection, page, item_count, id, func))
                    }
                    else
                        dispatch(serviceActionErrorSet("error"))
                    //    alert(response.data.message)
                    break;
                default:
                    console.log("default")
            }
        }).catch((e) => {
        console.log("ahmad=> error", e)
        switch (type) {
            case typeExport.TypeGetAddTaskOperationSatiaScreen:
                dispatch(serviceActionError(e, page))

                break;
            case typeExport.TypeSetAddTaskOperationSatiaScreen:
                dispatch(serviceActionErrorSet(e))
                break;
            default:
        }
    })
}


export const callWebservice = (getState, url, params, type, typeConnection, page, item_count, id, func) => {

    return dispatch => {


        // NetInfo.getConnectionInfo().done(
        //     (isConnected) => {
        //         if (isConnected) {
        //             getDataDisatch(dispatch, getState, url, params, type, typeConnection, page, item_count, id, func);
        //         } else {
        //             dispatch(serviceActionError("No Internet Connection", page));
        //
        //         }
        //     }
        // )

        if (store.getState().reducerSplashSatiaScreen.Connection) {
            getDataDisatch(dispatch, getState, url, params, type, typeConnection, page, item_count, id, func);
        } else {
            switch (type) {
                case typeExport.TypeGetAddTaskOperationSatiaScreen:
                    dispatch(serviceActionError('error_Connection', page))

                    break;
                case typeExport.TypeSetAddTaskOperationSatiaScreen:
                    dispatch(serviceActionErrorSet('error_Connection'))
                    break;
                default:
            }
        }


    }
}

export const serviceActionPendingSet = (id) => ({
    type: typeExport.SetAddTaskOperationSatiaScreen_SERVICE_PENDING,
    NoInternetDialogSet: false,
    isLoadingSet: true,
    resultsSet: null,
    id: id

})

export const serviceActionErrorSet = (error) => ({
    type: typeExport.SetAddTaskOperationSatiaScreen_SERVICE_ERROR,
    NoInternetDialogSet: true,
    isLoadingSet: false,
    error: error
})

export const serviceActionSuccessSet = (data, id) => ({
    type: typeExport.SetAddTaskOperationSatiaScreen_SERVICE_SUCCESS,
    NoInternetDialogSet: false,
    isLoadingSet: false,
    resultsSet: data,
    id: id,
})
export const serviceActionPending = () => ({
    type: typeExport.AddTaskOperationSatiaScreen_SERVICE_PENDING,
    NoInternetDialog: false,
    showRefresh: false,
    isLoading: true,
    lazyload_end: false,
    empty: false,
    failed: false
})

export const serviceActionError = (error, page) => ({
    type: typeExport.AddTaskOperationSatiaScreen_SERVICE_ERROR,
    NoInternetDialog: true,
    showRefresh: false,
    isLoading: false,
    lazyload_end: true,
    empty: false,
    failed: true,
    page: page,
    error: error
})
export const serviceActionRefresh = () => ({
    type: typeExport.AddTaskOperationSatiaScreen_SERVICE_REFRESH,
    results: [],
    NoInternetDialog: false,
    showRefresh: true,
    lazyload_end: false,
    isLoading: false,
    resultsSet: [],
    NoInternetDialogSet: false,
    isLoadingSet: false,
    empty: false,
    failed: false,
    page: 1,

})
export const serviceActionSuccess = (data, page, allResult) => ({

    type: typeExport.AddTaskOperationSatiaScreen_SERVICE_SUCCESS,
    NoInternetDialog: false,
    results: data,
    allResult: allResult,
    //  resultsFavourite: data,
    showRefresh: false,
    lazyload_end: false,
    isLoading: true,
    empty: false,
    failed: false,
    page: page
})
export const serviceActionEnd = (data, page, allResult) => ({
    type: typeExport.AddTaskOperationSatiaScreen_SERVICE_END,
    results: data,
    NoInternetDialog: false,
    showRefresh: false,
    lazyload_end: true,
    isLoading: false,
    empty: false,
    failed: false,
    page: page,
    allResult: allResult,

})
export const serviceActionEmpty = (page, allResult) => ({
    type: typeExport.AddTaskOperationSatiaScreen_SERVICE_Empty,
    NoInternetDialog: false,
    showRefresh: false,
    lazyload_end: true,
    isLoading: false,
    empty: true,
    failed: false,
    page: page,
    allResult: allResult,

})
export const serviceActionAddFirstData = (data, item_count) => ({
    type: typeExport.AddTaskOperationSatiaScreen_SERVICE_ADD_FIRST_DATA,
    results: data,
    NoInternetDialog: false,
    showRefresh: false,
    lazyload_end: (data.length < item_count) ? true : false,
    isLoading: false,
    empty: data.length == 0 ? true : false,
    failed: false,
    page: 2
})

export const serviceActionChangeNotif = (data) => ({
    type: typeExport.AddTaskOperationSatiaScreen_SERVICE_CHANGE_NOTIF,

    data: data
})
export const serviceActionAddSubList = (data) => ({

    type: typeExport.AddTaskOperationSatiaScreen_SERVICE_AddSubList,

    data: data,

})

export const serviceActionListFilter = (data) => ({

    type: typeExport.AddTaskOperationSatiaScreen_SERVICE_LIST_FILTER,

    ListFilter: data,

})
export default connect(mapStateToProps, mapDispatchToProps)(AddTaskOperationSatiaScreen);
